import { QrPdfTemplatePlatformStyles } from './qr-pdf-template-platform-styles.types';

export const levelWorksQRPDFTemplateColors: QrPdfTemplatePlatformStyles = {
  pageBackground: '#FDF7DE',
  text: '#111111',
  qrBackground: '#FFFFFF',
  qrBorder: '#111111',
  footerLogoHeight: 100,
};

export const hollandworxQRPDFTemplateColors: QrPdfTemplatePlatformStyles = {
  pageBackground: '#FFFFFF',
  text: '#111111',
  qrBackground: '#FFFFFF',
  qrBorder: '#111111',
  footerLogoWidth: 100,
  footerLogoHeight: 'auto',
};

export const aethonQRPDFTemplateColors: QrPdfTemplatePlatformStyles = {
  pageBackground: '#B39EE0',
  text: '#111111',
  qrBackground: '#FFFFFF',
  qrBorder: null,
  footerLogoHeight: 100,
};

export const opusQRPDFTemplateColors: QrPdfTemplatePlatformStyles = {
  pageBackground: '#d6eef8',
  text: '#111111',
  qrBackground: '#FFFFFF',
  qrBorder: '#111111',
};
